import { http } from './http';
import { api } from './endpoints';

export const resourcesService = {
    rabattVertraege(id: number | string) {
        return http.get(api.resources.rabattVertraege(id)).then(r => r.data);
    },
    dictionaryArea(area: string) {
        return http.get(api.resources.dictionaryArea(area)).then(r => r.data);
    },
    publicImageApiUrl() {
        return http.get(api.resources.publicImageApi).then(r => r.data);
    },
    pflichttextUrl() {
        return http.get(api.resources.pflichttextUrl).then(r => r.data);
    },
};
export type ResourcesService = typeof resourcesService;
